import { Plugin } from "@ckeditor/ckeditor5-core";
import ApplyNoBreakCommand from "./NoBreakCommand";

export default class NoBreakEditing extends Plugin {
  init() {
    const editor = this.editor;

    this._defineSchema();
    this._defineConverters();

    editor.commands.add("applyNoBreak", new ApplyNoBreakCommand(this.editor));

    if (editor.plugins.has("TrackChangesEditing")) {
      const trackChangesEditing = editor.plugins.get("TrackChangesEditing");
      trackChangesEditing.enableCommand("applyNoBreak");
    }
  }

  _defineConverters() {
    const editor = this.editor;
    const conversion = editor.conversion;

    editor.conversion.for("upcast").elementToElement({
      view: {
        name: "span",
        styles: {
          "white-space": "nowrap",
        },
      },
      model: "nobreak",
    });

    editor.conversion.for("dataDowncast").elementToElement({
      model: "nobreak",
      view: {
        name: "span",
        styles: {
          "white-space": "nowrap",
        },
      },
    });

    editor.conversion.for("editingDowncast").elementToElement({
      model: "nobreak",
      view: {
        name: "span",
        styles: {
          "white-space": "nowrap",
        },
        attributes: {
          title: "No Break",
        },
      },
    });
  }

  _defineSchema() {
    const schema = this.editor.model.schema;

    schema.register("nobreak", {
      allowContentOf: "$block",
      allowIn: "$block",
      isInline: true,
    });
    schema.setAttributeProperties("nobreak", {
      isFormatting: true,
      copyOnEnter: false,
    });
  }
}
